import React from 'react';

import './button.scss';
import classNames from 'classnames';

export const Button = (props) => {
  const { onClick, title, size = 'xl', color = 'default', icon } = props;

  const buttonStyles = classNames('button', {
    xlarge: size === 'xl',
    large: size === 'l',
    white: color === 'white',
  });

  return (
    <button className={buttonStyles} onClick={onClick}>
      {/* <div style={{ visibility: 'hidden' }}>{title}</div> */}
      <div className="button-title">
        {title} {icon && <img className="button-icon" src={icon} alt={icon} />}
      </div>
    </button>
  );
};
